import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../css/home.module.css';
import useDualCtrlNav from './pirogov-dev/useDualCtrlNav';

const AIbrainHome = () => {
  useDualCtrlNav();
  return (
    <div className={styles.wrapper}>
      <div className={styles.decoTop} />
      <div className={styles.decoBottom} />

      <div className={styles.container}>
        <div className={styles.header}>
          <h1><a href="/" style={{ color: 'inherit', textDecoration: 'none' }}>AI Brain Studio</a></h1>
          <p>Выберите интерактивный стол для создания анатомических сцен</p>
        </div>

        <div className={styles.cardsSection}>
          <Link to="/pirogov/presets-creator/" className={styles.card}>
            <div className={styles.cardIcon}>📚</div>
            <h2 className={styles.cardTitle}>Пирогов</h2>
            <div className={styles.cardArrow}>Начать →</div>
          </Link>

          <Link to="/anatomage/presets-creator/" className={styles.card}>
            <div className={styles.cardIcon}>🔬</div>
            <h2 className={styles.cardTitle}>Anatomage</h2>
            <div className={styles.cardArrow}>Начать →</div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AIbrainHome;
